import { render, staticRenderFns } from "./ChoiceToggle.vue?vue&type=template&id=f7b9b350&"
import script from "./ChoiceToggle.vue?vue&type=script&lang=ts&"
export * from "./ChoiceToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports